// src/components/AdminDashboard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';
import './AdminDashboardModern.css';

const AdminDashboard = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    document.body.classList.remove('intro-active');
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
    };
  }, []);

  const adminModules = [
    {
      id: 'insights',
      title: 'Analytics & Insights',
      description: 'View performance metrics, lead analytics, and business intelligence reports',
      icon: '📊',
      color: '#1B96FF',
      path: '/admin/insights'
    },
    {
      id: 'mail-marketing',
      title: 'Paper Mail Marketing',
      description: 'Create, manage, and track physical mail campaigns and direct mail sequences',
      icon: '📮',
      color: '#FF6B35',
      path: '/admin/mail-marketing'
    },
    {
      id: 'client-manager',
      title: 'Client Management',
      description: 'Manage client relationships, track interactions, and view client history',
      icon: '👥',
      color: '#4CAF50',
      path: '/admin/client-manager'
    },
    {
      id: 'digital-ads',
      title: 'Digital Advertising',
      description: 'Manage Facebook, Google, and social media advertising campaigns',
      icon: '📱',
      color: '#9C27B0',
      path: '/admin/digital-ads'
    },
    {
      id: 'blog-manager',
      title: 'Content Management',
      description: 'Create, edit, and publish blog posts and marketing content',
      icon: '📝',
      color: '#FF9800',
      path: '/admin/blog-manager'
    },
    {
      id: 'reviews',
      title: 'Review Management',
      description: 'Monitor, respond to, and manage customer reviews and testimonials',
      icon: '⭐',
      color: '#FFC107',
      path: '/admin/reviews'
    },
    {
      id: 'email-manager',
      title: 'Email Manager',
      description: 'Create email templates and setup automated drip campaigns',
      icon: '📧',
      color: '#17a2b8',
      path: '/admin/email-manager'
    },
    {
      id: 'agent-referral',
      title: 'Agent Referral',
      description: 'Refer agents and track your referral submissions',
      icon: '🤝',
      color: '#e74c3c',
      path: '/admin/agent-referral'
    },
    {
      id: 'settings',
      title: 'System Settings',
      description: 'Configure account settings, preferences, and system configurations',
      icon: '⚙️',
      color: '#607D8B',
      path: '/admin/settings'
    }
  ];

  return (
    <div className="admin-dashboard-modern">
      {/* Header */}
      <header className="admin-header-modern">
        <div className="header-content">
          <div className="header-left">
            <h1 className="dashboard-title">Admin Console</h1>
            <p className="dashboard-subtitle">Manage your real estate business operations</p>
          </div>
          <div className="header-right">
            <button onClick={() => navigate('/admin/agent-winds')} className="agent-winds-launch-btn">
              <svg
                className="agent-winds-launch-icon"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <defs>
                  <linearGradient id="agentWindsIconFade" x1="0" y1="0" x2="24" y2="0" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="currentColor" stopOpacity="1" />
                    <stop offset="0.65" stopColor="currentColor" stopOpacity="0.72" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0.12" />
                  </linearGradient>
                </defs>
                <path
                  d="M5 19c0-2.2 2.1-3.1 3.5-3.6 1.5-.5 2-1.8 1.6-3.1-.5-1.4-1-2.8-.5-5 .6-2.5 3-3.8 5.1-3.8 2.3 0 4 1.4 4.5 3.8.5 2.2 0 3.6-.5 5-.4 1.3.1 2.6 1.6 3.1 1.4.5 3.2 1.4 3.2 3.6"
                  stroke="url(#agentWindsIconFade)"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path d="M2.5 6.5h4.4M1.8 11.5h4.8M3.2 16h3.7" stroke="url(#agentWindsIconFade)" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2 2" />
              </svg>
              <span>Agent Winds</span>
            </button>
            <button onClick={() => navigate('/')} className="back-home-btn-modern">
              Back to Site
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="admin-main-content">
        <div className="modules-grid">
          {adminModules.map((module) => (
            <div 
              key={module.id}
              className="module-card"
              onClick={() => navigate(module.path)}
              style={{'--module-color': module.color}}
            >
              <div className="module-header">
                <div className="module-icon" style={{backgroundColor: module.color}}>
                  {module.icon}
                </div>
                <div className="module-badge">Active</div>
              </div>
              <div className="module-content">
                <h3 className="module-title">{module.title}</h3>
                <p className="module-description">{module.description}</p>
              </div>
              <div className="module-footer">
                <span className="module-action">Open Module →</span>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;
